import React, { FC } from 'react';
import { Grid, Header } from 'semantic-ui-react';
import { TranslationComponent } from '../../../../TranslationComponent';
import { ESicurezzaAntincendio } from '@relab/alstom-ptw-shared';
import { InputLabel } from '../../../../styled/InputLabel.styled';
import { Field } from 'formik';

const protezioneAntincendioKeys = Object.keys(ESicurezzaAntincendio).slice(0, 3);
const precauzioniDistanzaKeys = Object.keys(ESicurezzaAntincendio).slice(3, 10);
const precauzioniStruttureKeys = Object.keys(ESicurezzaAntincendio).slice(10, 12);
const precauzioniAttrezzatureKeys = Object.keys(ESicurezzaAntincendio).slice(12, 14);
const vigilanzaAntincendioKeys = Object.keys(ESicurezzaAntincendio).slice(14);

type FieldsListProps = {
  fieldKeys: string[];
};

const FieldsList: FC<FieldsListProps> = ({ fieldKeys }) => (
  <>
    {fieldKeys.map((key) => (
      <Grid.Row key={key}>
        <Grid.Column>
          <InputLabel className={'label-misure-e-controlli'}>
            <Field type="checkbox" name="misureEControlli" value={key} />

            <span>
              <TranslationComponent stringKey={key} shouldUnescape />
            </span>
          </InputLabel>
        </Grid.Column>
      </Grid.Row>
    ))}
  </>
);

export const SicurezzaAntincendio: FC = () => {
  return (
    <>
      <Header size="small">
        <TranslationComponent stringKey={'Protezione antincendio'} />
      </Header>

      <Grid>
        <FieldsList fieldKeys={protezioneAntincendioKeys} />
      </Grid>

      <Header size="small">
        <TranslationComponent stringKey={'Precauzioni entro il raggio di 10 m di distanza'} />
      </Header>

      <Grid>
        <FieldsList fieldKeys={precauzioniDistanzaKeys} />
      </Grid>

      <Header size="small">
        <TranslationComponent stringKey={'Precauzioni per le strutture dell’edificio'} />
      </Header>

      <Grid>
        <FieldsList fieldKeys={precauzioniStruttureKeys} />
      </Grid>

      <Header size="small">
        <TranslationComponent stringKey={'Precauzioni per attrezzature e macchinari'} />
      </Header>

      <Grid>
        <FieldsList fieldKeys={precauzioniAttrezzatureKeys} />
      </Grid>

      <Header size="small">
        <TranslationComponent stringKey={'Vigilanza antincendio'} />
      </Header>

      <Grid>
        <FieldsList fieldKeys={vigilanzaAntincendioKeys} />
      </Grid>
    </>
  );
};
